import { Coding, Quantity } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputDecimal } from '../decimalInput'
import { SearchInput } from '../select/SearchableSelect'
import { InputQuantityProps } from './types'

function UnitFromQuantity(value: Quantity | null): Coding | null {
  if (!value) return null
  if (!value.system && !value.code && !value.unit) return null

  return {
    display: value.unit,
    system: value.system,
    code: value.code
  }
}

export default function ChoiceQuantityInput({
  disabled,
  getUnitOptions,
  inputId,
  onChangeValue,
  onChangeUnit,
  required,
  value
}: InputQuantityProps) {
  return (
    <div className='grid grid-cols-12 gap-2'>
      <div className='col-span-8'>
        <InputDecimal
          disabled={disabled}
          id={inputId}
          name={`${inputId}-quantity`}
          onChange={onChangeValue}
          required={required}
          value={value?.value?.toString()}
        />
      </div>
      <div className='col-span-4'>
        <SearchInput
          getOptions={getUnitOptions}
          name={`${inputId}-unit`}
          onChange={onChangeUnit}
          placeholder='unit'
          value={UnitFromQuantity(value)}
        />
      </div>
    </div>
  )
}
